﻿/**
 * @fileOverview Overlay() setup
 *
 * @author John Allan
 */

/*! RESAAS - Licensed under MIT */

define('overLay', ['jquery','pubsub', 'smoke', 'generalUtilities'], function overlayUtilities($, pubsub, smoke, generalUtilities) {
	return function overlayUtilitiesInstance() {
		'use strict';

		var settings, elements, module;

		settings = {
			backgroundSelector: '.js-overlay-background',
			displaySelector: '.js-overlay-display',
			contentSelector: '.js-overlay-content',
			closeSelector: '.js-overlay-close-btn',
			overflowClass: 're-overlay-stick-content',
			overlayOpenClass: 're-overlay-open',
			pageContentSelector: '.re-page-outer-wrapper',
			topOffset: 75,
			idprefix: 'oid-',
			idattr: 'data-oid',
			defaults: {
				watchFormData: true
			}
		};

		window.re_overlay_utilities_values = window.re_overlay_utilities_values || {};
		elements = {};
		module = {};
		module.private = {};

		// Public Methods

		module.openOverlay = function openOverlay(html, o) {
			var overlay, display, scrollTop, oid, options, offset;

			// store reference to elements
			overlay = $(html);
			display = overlay.find(settings.displaySelector);
			oid = module.private.createUniqueId();
			options = $.extend({}, o);

			// attach oid
			overlay.attr(settings.idattr, oid);

			// find the page scroll offset
			scrollTop = elements.document.scrollTop();
			options.scrollTop = scrollTop;

			// set window to top
			window.scrollTo(0, 0);

			// save overlay reference
			module.private.saveOverlayReference(overlay);

			// save form state
			module.private.saveFormState(overlay, oid);

			// save overlay config
			module.private.saveOverlayConfig(options, oid);

			// set the top position of our overlay
			offset = window.re_overlay_utilities_values.overlays.length * settings.topOffset;
			display.css('top', offset);

			// bind events
			overlay.on('click', settings.closeSelector, module.private.handleCloseClick);

			if (options.modal !== true) {
				overlay.on('click', settings.backgroundSelector, module.private.handleCloseClick);
			}

			// stop body scroll
			$('html').addClass(settings.overlayOpenClass);
			$(settings.pageContentSelector).addClass(settings.overflowClass).css({
				top: scrollTop * -1,
			});

			// add our overlay to DOM
			elements.body.append(overlay);

			return overlay;
		};

		module.getCurrentOverlay = function getCurrentOverlay() {
			var overlay, l;

			l = window.re_overlay_utilities_values.overlays.length;

			overlay = l ? window.re_overlay_utilities_values.overlays[l - 1] : null;

			return overlay;
		};

		module.closeAllOverlays = function closeAllOverlays(force) {
			var f, overlaysLength;

			f = force || false;
			overlaysLength = generalUtilities.prop(window, 're_overlay_utilities_values.overlays.length');

			if (overlaysLength) {
				while (window.re_overlay_utilities_values.overlays.length) {
					module.closeOverlay(f);
				}
			}
		};

		module.closeOverlay = function closeOverlay(force) {
			var o, overlay, oid, overlaysLength;

			overlaysLength = generalUtilities.prop(window, 're_overlay_utilities_values.overlays.length');

			if (overlaysLength) {
				o = window.re_overlay_utilities_values.overlays[overlaysLength - 1];
				overlay = module.getCurrentOverlay();
				oid = $(overlay).attr('data-oid');

                if (typeof window.re_overlay_utilities_values.overlayConfig[oid].onClose === 'function') {
                    window.re_overlay_utilities_values.overlayConfig[oid].onClose();
                }

				if (
					!force &&
					module.private.formHasChanged(o) &&
					window.re_overlay_utilities_values.overlayConfig[oid].watchFormData === true
				) {
					smoke.confirm(
						RESAAS.Localization.Global.EXIT_NOW_AND_LOSE_FORM_DATA,
						function smokeConfirmCallback(e) {
							if (e) {
								module.private.closeCurrentOverlay(oid);
							} else {
								return false;
							}
						},
						{ ok: RESAAS.Localization.Global.OK_CAP, cancel: RESAAS.Localization.Global.CANCEL_CAP }
					);
				} else {
					module.private.closeCurrentOverlay(oid);
				}
			}
		};

		module.saveCurrentOverlayFormState = function saveCurrentOverlayFormState() {
			var overlay, oid;

			overlay = module.getCurrentOverlay();
			oid = $(overlay).attr('data-oid');
			module.private.saveFormState(overlay, oid);
		};

		// Private Functions

		module.private.createUniqueId = function createUniqueId(prefix) {
			var pre;

			pre = prefix || settings.idprefix;
			window.re_overlay_utilities_values.guidIndex = window.re_overlay_utilities_values.guidIndex
				? window.re_overlay_utilities_values.guidIndex + 1
				: 1;

			return pre + window.re_overlay_utilities_values.guidIndex;
		};

		module.private.closeCurrentOverlay = function closeCurrentOverlay(oid) {
			var config, o;

			if (window.re_overlay_utilities_values.overlays.length === 1) {
				$(settings.pageContentSelector).removeClass(settings.overflowClass);
				$('html').removeClass(settings.overlayOpenClass);
			}

			config = window.re_overlay_utilities_values.overlayConfig[oid];
			window.scrollTo(0, config.scrollTop);

			o = window.re_overlay_utilities_values.overlays.pop();
			o.remove();
		};

		module.private.saveOverlayReference = function saveOverlayReference(overlay) {
			if (window.re_overlay_utilities_values.overlays === undefined) {
				window.re_overlay_utilities_values.overlays = [];
			}
			window.re_overlay_utilities_values.overlays.push(overlay);
		};

		module.private.saveFormState = function saveFormState(overlay, oid) {
			var formels, formdata;

			formels = overlay.find(':input');
			window.re_overlay_utilities_values.formStates = window.re_overlay_utilities_values.formStates || {};

			if (formels.length === 0) {
				return false;
			}

			formdata = formels.serialize();
			window.re_overlay_utilities_values.formStates[oid] = formdata;
		};

		module.private.saveOverlayConfig = function saveOverlayConfig(options, oid) {
			var config;

			config = $.extend(true, {}, settings.defaults, options);

			window.re_overlay_utilities_values.overlayConfig = window.re_overlay_utilities_values.overlayConfig || {};
			window.re_overlay_utilities_values.overlayConfig[oid] = config;
		};

		module.private.formHasChanged = function formHasChanged(o) {
			var current, id;

			id = o.attr(settings.idattr);
			if (window.re_overlay_utilities_values.formStates[id]) {
				current = o.find(':input').serialize();
				if (current === window.re_overlay_utilities_values.formStates[id]) {
					return false;
				}

				return true;
			}

			return false;
		};

		// Event Handlers

		module.private.handleCloseClick = function handleCloseClick(e) {
			var mixpanelAttr, dataAttr;
			mixpanelAttr= {};
			e.preventDefault();

			if (e.target.dataset.mixpanelName) {
				dataAttr = e.target.dataset;
				mixpanelAttr.name = dataAttr.mixpanelName;
				if (dataAttr.mixpanelFrom) { mixpanelAttr.from = dataAttr.mixpanelFrom; }
				if (dataAttr.mixpanelContext) { mixpanelAttr.context = dataAttr.mixpanelContext; }
				if (dataAttr.mixpanelType) { mixpanelAttr.type = dataAttr.mixpanelType; }
				pubsub.publish('mixpanel.Intent', mixpanelAttr);
			}

			module.closeOverlay();
		};

		module.init = function init() {
			// cache element references
			elements.html = $('html');
			elements.body = $('body');
			elements.document = $(document);
		};

		return module;
	};
});
